import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const EMAIL = "hello@getfetcher.in";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0B0F19] text-white">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <img src="/logo-white.webp" alt="Fetcher" className="h-8 w-auto" />
          <p className="mt-4 text-sm font-medium leading-relaxed text-white/60">
            Buy anything, from any local shop. A nearby rider fetches it — even from shops that aren't online.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-white/40">Company</span>
          <Link data-testid="footer-link-riders" to="/riders" className="text-sm font-semibold text-white/80 transition hover:text-[#E86E28]">
            Become a Rider
          </Link>
          <Link data-testid="footer-link-privacy" to="/privacy-policy" className="text-sm font-semibold text-white/80 transition hover:text-[#E86E28]">
            Privacy Policy
          </Link>
          <Link data-testid="footer-link-terms" to="/terms" className="text-sm font-semibold text-white/80 transition hover:text-[#E86E28]">
            Terms &amp; Conditions
          </Link>
          <Link data-testid="footer-link-contact" to="/contact" className="text-sm font-semibold text-white/80 transition hover:text-[#E86E28]">
            Contact
          </Link>
        </div>

        <div className="flex flex-col gap-3">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-white/40">Reach us</span>
          <a
            data-testid="footer-email"
            href={`mailto:${EMAIL}`}
            className="inline-flex items-center gap-2 text-sm font-semibold text-white/80 transition hover:text-[#E86E28]"
          >
            <Mail className="h-4 w-4" />
            {EMAIL}
          </a>
        </div>
      </div>

      <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
        <p className="text-sm font-medium text-white/40">© 2026 Fetcher. All rights reserved.</p>
        <p className="text-xs font-medium text-white/30">Registered office: Tamil Nadu, India</p>
      </div>
    </div>
  </footer>
);
